import { useContext, useEffect } from "react";
import { Table } from "react-bootstrap";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import Breadcrumbs from "../../../utils/Breadcrumbs/Breadcrumbs";
import SiteTitle from "../../../utils/SiteTitle/SiteTitle";
import EmptyData from "../../../utils/EmptyData/EmptyData";
import CardLayout from "../../../utils/CardLayout/CardLayout";
import PaginationList from "../../../utils/PaginationList/PaginationList";
import CustomModal from "./../../../utils/CustomModal/CustomModal";
import TooltipTitle from "../../../utils/TooltipTitle/TooltipTitle";
import ItemInfo from "./../../../utils/ItemInfo/ItemInfo";
import { ConvertCurrency } from "../../../utils/Currency/Currency";
import { numberSeparate, paymentStatusItems } from "../../../utils";
import { paymentTransactionAdminContext } from "../../../context/Admin/PaymentTransactionAdminContext/PaymentTransactionAdminContext";
import { areYouSureMessage } from "../../../utils/toastMessage/toastMessage";

const PaymentTransactionAdmin = () => {
  const { pathname } = useLocation();

  const permission = useSelector((state) => state.permission);

  const {
    paymentTransactions,
    paymentTransaction,
    search,
    setSearch,
    ordering,
    setOrdering,
    limit,
    setLimit,
    totalCount,
    status,
    setStatus,
    pageNumber,
    setPageNumber,
    handleGetPaymentTransactions,
    handleGetPaymentTransaction,
    handleDeletePaymentTransaction,
    handleClosePaymentTransactionModal,
  } = useContext(paymentTransactionAdminContext);

  useEffect(() => {
    handleGetPaymentTransactions();
  }, [pageNumber, limit, ordering, status]);

  const onNavigate = (pk) => {
    window.open(
      `${pathname?.replace("PaymentTransaction", "Orders")}/${pk}`,
      "_blank"
    );
  };

  const requestSort = (key) => {
    let direction = "";
    if (ordering.includes(key) && !ordering.includes("-")) direction = "-";

    setOrdering(`${direction}${key}`);
  };

  const sortIcon = (key) => {
    const isCurrent = ordering.includes(key);
    const direction = isCurrent
      ? ordering.includes("-")
        ? "desc"
        : "asc"
      : "";
    return (
      <span onClick={() => requestSort(key)} className="cursor-pointer">
        <i
          className={`fas fa-sort-amount-${
            direction === "asc"
              ? "up text-primary"
              : direction === "desc"
              ? "down text-primary"
              : "up"
          }`}
        />
      </span>
    );
  };

  const sortByOptions = [
    {
      label: "تاریخ ایجاد",
      options: [
        { title: "نزولی", value: "-created_time" },
        { title: "صعودی", value: "created_time" },
      ],
    },
    {
      label: "وضعیت",
      options: [
        { title: "نزولی", value: "-status" },
        { title: "صعودی", value: "status" },
      ],
    },
    {
      label: "مبلغ",
      options: [
        { title: "نزولی", value: "-amount" },
        { title: "صعودی", value: "amount" },
      ],
    },
  ];

  return (
    <>
      <SiteTitle title="سوابق پرداخت" />
      <Breadcrumbs
        navs={[
          { name: "داشبورد", url: "/Admin/Dashboard", type: "l" },
          { name: "سوابق پرداخت", type: "a" },
        ]}
        title="لیست سوابق پرداخت"
      />

      <CardLayout>
        <form
          className="input-group mb-3"
          onSubmit={handleGetPaymentTransactions}
        >
          <input
            type="text"
            name="search"
            autoComplete="off"
            placeholder="جستجو ..."
            className="form-control"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <div className="input-group-append">
            <button type="submit" className="btn btn-primary">
              جستجو
            </button>
          </div>
        </form>
        <div className="row">
          <div className="col-12 col-md-6 col-lg-3 mb-2">
            <TooltipTitle title="وضعیت">
              <select
                className="form-control"
                name="status"
                onChange={(e) => setStatus(e.target.value)}
              >
                <option selected value="">
                  وضعیت: همه
                </option>
                <option selected={"true" === status} value="true">
                  موفق
                </option>
                <option selected={"false" === status} value="false">
                  ناموفق
                </option>
              </select>
            </TooltipTitle>
          </div>
          <div className="col-12 col-md-6 col-lg-3 mb-2">
            <TooltipTitle title="مرتب سازی بر اساس">
              <select
                className="form-control"
                value={ordering}
                onChange={(e) => setOrdering(e.target.value)}
              >
                {sortByOptions.map((_item, index) => (
                  <optgroup label={_item.label} key={index}>
                    {_item.options?.map((option) => (
                      <option
                        key={option.value}
                        selected={ordering === option.value}
                        value={option.value}
                      >
                        {option.title}
                      </option>
                    ))}
                  </optgroup>
                ))}
              </select>
            </TooltipTitle>
          </div>
        </div>
        {isEmpty(paymentTransactions) ? (
          <EmptyData />
        ) : (
          <>
            <div className="d-flex justify-content-between align-items-center">
              <PaginationList
                setPageNumber={setPageNumber}
                pageCount={totalCount / limit}
              />
              <div>
                <select
                  className="form-control mb-3"
                  onChange={(e) => setLimit(Number(e.target.value))}
                >
                  <option value={10} selected={10 === limit}>
                    10
                  </option>
                  <option value={25} selected={25 === limit}>
                    25
                  </option>
                  <option value={50} selected={50 === limit}>
                    50
                  </option>
                  <option value={75} selected={75 === limit}>
                    75
                  </option>
                  <option value={100} selected={100 === limit}>
                    100
                  </option>
                </select>
              </div>
            </div>
            <Table responsive hover borderless striped>
              <thead className="thead-dark text-center">
                <tr>
                  <th>#</th>
                  <th>نام و نام خانوادگی</th>
                  <th>شماره موبایل</th>
                  <th>تاریخ ایجاد {sortIcon("created_time")}</th>
                  <th>وضعیت {sortIcon("status")}</th>
                  <th>مبلغ (ريال) {sortIcon("amount")}</th>
                  <th className="text-center">
                    تعداد کل :{" "}
                    <span className="badge badge-primary font-weight-bold p-1">
                      {totalCount}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody className="text-center">
                {paymentTransactions.map((_item, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>
                      {_item?.client?.first_name} {_item?.client?.last_name}
                    </td>
                    <td>{_item?.client?.mobile}</td>
                    <td>{_item?.created_time}</td>
                    <td>{paymentStatusItems[_item?.status]}</td>
                    <td>
                      <ConvertCurrency price={_item?.amount} />
                    </td>
                    <td>
                      <button
                        onClick={() => onNavigate(_item?.order?.pk)}
                        className="btn btn-primary mr-2"
                        disabled={!_item?.order?.pk}
                      >
                        سفارش
                      </button>
                      {permission.payment_transactions_get && (
                        <button
                          onClick={() => handleGetPaymentTransaction(_item?.id)}
                          className="btn btn-info mr-2"
                        >
                          جزئیات
                        </button>
                      )}
                      {permission.payment_transactions_delete && (
                        <i
                          onClick={() =>
                            areYouSureMessage(
                              () => handleDeletePaymentTransaction(_item),
                              `آیا از حذف سابقه پرداخت ${_item?.client?.first_name} ${_item?.client?.last_name} اطمینان دارید؟`
                            )
                          }
                          className="fa fa-trash-alt fa-2x text-danger cursorPointer"
                        />
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
      </CardLayout>

      {/* Start Details Modal */}
      <CustomModal
        title="جزئیات پرداخت"
        show={!isEmpty(paymentTransaction)}
        onHide={handleClosePaymentTransactionModal}
        size="xl"
      >
        <div className="container">
          <div>
            <p className="text-info fw-bold text-center">مشتری</p>

            <div className="row">
              <ItemInfo label="نام و نام خانوادگی">
                <p>
                  {paymentTransaction?.client?.first_name}{" "}
                  {paymentTransaction?.client?.last_name}
                </p>
              </ItemInfo>
              <ItemInfo label="شماره موبایل">
                <p>{paymentTransaction?.client?.mobile}</p>
              </ItemInfo>
              <ItemInfo label="نام کاربری">
                <p>{paymentTransaction?.client?.username}</p>
              </ItemInfo>
            </div>

            <hr />
          </div>
          <div>
            <p className="text-info fw-bold text-center">اطلاعات پرداخت</p>

            <div className="row">
              <ItemInfo label="مبلغ">
                <ConvertCurrency price={paymentTransaction?.amount} />
              </ItemInfo>
              <ItemInfo label="شماره کارت">
                <p>{paymentTransaction?.cardnumbermasked}</p>
              </ItemInfo>
              <ItemInfo label="توکن">
                <p>{paymentTransaction?.token}</p>
              </ItemInfo>
              <ItemInfo label="کدپیگیری">
                <p>{paymentTransaction?.paygatetranid}</p>
              </ItemInfo>
            </div>

            <hr />
          </div>
          {!isEmpty(paymentTransaction?.invoice) && (
            <div>
              <p className="text-info fw-bold text-center">فاکتور</p>

              <div className="row align-items-center">
                <ItemInfo label="شماره فاکتور">
                  {numberSeparate(paymentTransaction?.invoice?.pk)}
                </ItemInfo>

                <ItemInfo label="اجرت (ریال)">
                  <ConvertCurrency price={paymentTransaction?.invoice?.fee} />
                </ItemInfo>

                <ItemInfo label="هزینه قطعه (ریال)">
                  <ConvertCurrency price={paymentTransaction?.invoice?.piece} />
                </ItemInfo>

                <ItemInfo label="مالیات (ریال)">
                  <ConvertCurrency price={paymentTransaction?.invoice?.tax} />
                </ItemInfo>

                <ItemInfo label="تخفیف (ریال)">
                  <ConvertCurrency
                    price={paymentTransaction?.invoice?.discount?.amount}
                  />
                </ItemInfo>
                <ItemInfo label="فاکتور رسمی">
                  <i
                    className={`fa fa-${
                      paymentTransaction?.invoice?.is_official
                        ? "check"
                        : "times"
                    } text-${
                      paymentTransaction?.invoice?.is_official
                        ? "success"
                        : "danger"
                    }`}
                  />
                </ItemInfo>
                <ItemInfo label="پرداخت شده">
                  <i
                    className={`fa fa-${
                      paymentTransaction?.invoice?.is_paid ? "check" : "times"
                    } text-${
                      paymentTransaction?.invoice?.is_paid
                        ? "success"
                        : "danger"
                    }`}
                  />
                </ItemInfo>

                <ItemInfo label="نوع پرداخت">
                  <p>
                    {paymentTransaction?.invoice?.method === 1
                      ? "اعتبار (کیف پول)"
                      : paymentTransaction?.invoice?.method === 2
                      ? "درگاه پرداخت"
                      : "نقدی"}
                  </p>
                </ItemInfo>

                <ItemInfo label="مجموع (ریال)">
                  <ConvertCurrency price={paymentTransaction?.invoice?.total} />
                </ItemInfo>
                <ItemInfo label="توضیحات">
                  <p>{paymentTransaction?.invoice?.description}</p>
                </ItemInfo>
                {!isEmpty(paymentTransaction?.invoice?.items) && (
                  <div className="col-12">
                    <Table responsive hover borderless>
                      <thead className="thead-light">
                        <th>عنوان</th>
                        <th>مبلغ (ریال)</th>
                        <th>توضیحات</th>
                      </thead>
                      <tbody>
                        {paymentTransaction?.invoice?.items?.map(
                          (_inv, idx) => (
                            <tr key={idx}>
                              <td>{_inv.name}</td>
                              <td>
                                <ConvertCurrency price={_inv?.price} />
                              </td>
                              <td>{_inv.description}</td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </Table>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </CustomModal>
      {/* End Details Modal */}
    </>
  );
};

export default PaymentTransactionAdmin;
